import { DynamicObject } from '../commonTypes';

const HamburgerMenu: DynamicObject = {
  home: 'HOME',
  freemovies: 'FREE_MOVIES',
  tvshows: 'TV_SHOWS',
  movies: 'MOVIES',
  sports: 'SPORTS',
  kids: 'KIDS',
  livetv: 'LIVE_TV',
  videos: 'VIDEOS',
  webstories: 'WEBSTORIES',
  exclusives: 'EXCLUSIVES',
  upcoming: 'UPCOMING',
  plex: 'PLEX',
  music: 'MUSIC',
  songs: 'SONGS',
  channels: 'CHANNELS',
  learning: 'LEARNING',
  premium: 'PREMIUM',
  news: 'NEWS',
  originals: 'WEBSERIES',
  play5: 'PLAY5',
  stories: 'STORIES',
  'tv-channels': 'TV_CHANNELS',
  HOME_KEY: 'home'
};

export const HAMBURGERMENU: Readonly<typeof HamburgerMenu> =
  Object.freeze(HamburgerMenu);
